<template>
  <div class="hidden" :id="item.post_name">
    <div class="">
      <div
        class="
          bg-green
          text-white text-lg text-center
          font-bold
          py-3
          rounded-t-3xl
        "
      >
        {{ item.post_title }}
      </div>
      <div class="py-3 px-5 text-center text-black">
        <div>Størrelse: {{ item.size }} m2</div>
        <div class="capitalize">{{ item.status }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
